import {
    HttpResponse,
    ScrapReasonWorkplaceModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ScrapReasonWorkplacesDataService implements CrudService<ScrapReasonWorkplaceModel, ScrapReasonWorkplaceModel> {
    getAll(query: CrudDataQuery<ScrapReasonWorkplaceModel>): Promise<CrudEnumerableResponse<ScrapReasonWorkplaceModel>> {
        return ApiService.api.getScrapReasonWorkplaceBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ScrapReasonWorkplaceModel>): Promise<CrudEnumerableResponse<ScrapReasonWorkplaceModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ScrapReasonWorkplaceModel>> {
        return ApiService.api.getScrapReasonWorkplaceById(id, params);
    }

    create(item: ScrapReasonWorkplaceModel, params?: RequestParams): Promise<CrudResponse<ScrapReasonWorkplaceModel>> {
        return ApiService.api.insertScrapReasonWorkplace(item, params);
    }

    update(item: ScrapReasonWorkplaceModel, params?: RequestParams): Promise<ScrapReasonWorkplaceModel> {
        return ApiService.api.updateScrapReasonWorkplace(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ScrapReasonWorkplaceModel> {
        return ApiService.api.patchScrapReasonWorkplace(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ScrapReasonWorkplaceModel>): Promise<CrudEnumerableResponse<ScrapReasonWorkplaceModel>> {
        return ApiService.api.deleteScrapReasonWorkplaces(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationScrapReasonWorkplace(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<ScrapReasonWorkplaceModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ScrapReasonWorkplaceModel, params?: RequestParams): Promise<CrudResponse<ScrapReasonWorkplaceModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getScrapReasonWorkplaceGroupped(query, params);
    }

}
